// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Modal,
//   Box,
//   IconButton,
// } from "@mui/material";
// import RotateLeftIcon from "@mui/icons-material/RotateLeft";
// import RotateRightIcon from "@mui/icons-material/RotateRight";
// import CloseIcon from "@mui/icons-material/Close";

// function ImageTable({ data }) {
//   const [open, setOpen] = useState(false);
//   const [modalImage, setModalImage] = useState("");
//   const [rotation, setRotation] = useState(0);

//   const handleOpen = (imgLink) => {
//     setModalImage(imgLink);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setRotation(0); // Reset rotation
//   };

//   const rotateLeft = () => {
//     setRotation((prevRotation) => prevRotation - 90);
//   };

//   const rotateRight = () => {
//     setRotation((prevRotation) => prevRotation + 90);
//   };

//   const modalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 400,
//     bgcolor: "background.paper",
//     boxShadow: 24,
//     p: 4,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: 2,
//   };

//   return (
//     <div>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Image Name</TableCell>
//               <TableCell>View</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {data.map((row, index) => (
//               <TableRow key={index}>
//                 <TableCell>{row.imgName}</TableCell>
//                 <TableCell>
//                   <Button onClick={() => handleOpen(row.imgName)}>
//                     View Image
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="modal-modal-title"
//         aria-describedby="modal-modal-description"
//       >
//         <Box sx={modalStyle}>
//           <IconButton onClick={handleClose}>
//             <CloseIcon />
//           </IconButton>
//           <img
//             src={modalImage}
//             alt="Displayed"
//             style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }}
//           />
//           <IconButton onClick={rotateLeft}>
//             <RotateLeftIcon />
//           </IconButton>
//           <IconButton onClick={rotateRight}>
//             <RotateRightIcon />
//           </IconButton>
//         </Box>
//       </Modal>
//     </div>
//   );
// }

// export default ImageTable;

// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   TextField,
//   Box,
//   Modal,
//   TablePagination,
//   Stack,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import { visuallyHidden } from "@mui/utils";
// import RotateLeftIcon from "@mui/icons-material/RotateLeft";
// import RotateRightIcon from "@mui/icons-material/RotateRight";

// function ImageTable({ data }) {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [open, setOpen] = useState(false);
//   const [modalImage, setModalImage] = useState("");
//   const [rotation, setRotation] = useState(0);

//   const filteredData = data.filter(
//     (row) =>
//       row.unitName.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       row.unitCode.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleOpen = (imgLink) => {
//     setModalImage(imgLink);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setRotation(0);
//   };

//   const rotateLeft = () => {
//     setRotation((prev) => prev - 90);
//   };

//   const rotateRight = () => {
//     setRotation((prev) => prev + 90);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <Paper
//       sx={{
//         width: "100%",
//         overflow: "hidden",
//       }}
//     >
//       <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
//         <TextField
//           variant="outlined"
//           size="small"
//           placeholder="Search by unit name or code..."
//           sx={{ margin: 2 }}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           InputProps={{
//             startAdornment: <SearchIcon position="start" />,
//           }}
//         />
//       </Stack>
//       <TableContainer sx={{ maxHeight: 440 }}>
//         <Table stickyHeader aria-label="sticky table">
//           <TableHead>
//             <TableRow>
//               <TableCell
//                 sx={{
//                   color: "blue",
//                   textTransform: "uppercase",
//                   padding: "10px",
//                   fontWeight: 600,
//                 }}
//               >
//                 S.No
//               </TableCell>
//               <TableCell
//                 sx={{
//                   color: "blue",
//                   textTransform: "uppercase",
//                   padding: "10px",
//                   fontWeight: 600,
//                 }}
//               >
//                 Unit Code
//               </TableCell>
//               <TableCell
//                 sx={{
//                   color: "blue",
//                   textTransform: "uppercase",
//                   padding: "10px",
//                   fontWeight: 600,
//                 }}
//               >
//                 Unit Name
//               </TableCell>
//               <TableCell
//                 sx={{
//                   color: "blue",
//                   textTransform: "uppercase",
//                   padding: "10px",
//                   fontWeight: 600,
//                 }}
//               >
//                 View
//               </TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {filteredData
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((row, index) => (
//                 <TableRow hover key={index}>
//                   <TableCell sx={{ padding: "10px" }}>
//                     {page * rowsPerPage + index + 1}
//                   </TableCell>
//                   <TableCell sx={{ padding: "0px" }}>{row.unitCode}</TableCell>
//                   <TableCell sx={{ padding: "0px" }}>{row.unitName}</TableCell>
//                   <TableCell sx={{ padding: "0px" }}>
//                     <IconButton onClick={() => handleOpen(row.imgName)}>
//                       <VisibilityIcon />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <TablePagination
//         rowsPerPageOptions={[5, 10, 25]}
//         component="div"
//         count={filteredData.length}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onPageChange={handleChangePage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//       />
//       <Modal open={open} onClose={handleClose}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 400,
//             bgcolor: "background.paper",
//             boxShadow: 24,
//             p: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             gap: 2,
//           }}
//         >
//           <img
//             src={modalImage}
//             alt="Modal Display"
//             style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }}
//           />
//           <Stack sx={{ display: "flex", flexDirection: "row" }}>
//             <IconButton onClick={rotateLeft}>
//               <RotateLeftIcon />
//             </IconButton>
//             <IconButton onClick={rotateRight}>
//               <RotateRightIcon />
//             </IconButton>
//           </Stack>
//         </Box>
//       </Modal>
//     </Paper>
//   );
// }

// export default ImageTable;

import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Button,
  Modal,
  Box,
  Stack,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import GetAppIcon from "@mui/icons-material/GetApp";
import * as XLSX from "xlsx";
import DateFormatter from "./DateFormatter";

function ImageTable({ data }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [rotation, setRotation] = useState(0);
  // const filteredData = data;
  const filteredData = data.filter(
    (row) =>
      row.SiteCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.SiteCode.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOpen = (imgLink) => {
    setModalImage(imgLink);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setRotation(0);
  };

  const rotateLeft = () => setRotation((prev) => prev - 90);
  const rotateRight = () => setRotation((prev) => prev + 90);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    XLSX.writeFile(wb, "exportedData.xlsx");
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      {/* <Stack
        sx={{
          display: "flex",
          alignItems: "flex-end",
          flexDirection: "row",
          justifyContent: "space-between",
          margin: 2,
        }}
      > */}
      {/* <TextField
          variant="outlined"
          size="small"
          placeholder="Search by unit name or code..."
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon position="start" />,
          }}
        /> */}
      <Button onClick={exportToExcel} variant="contained" color="primary">
        <GetAppIcon />
      </Button>
      {/* </Stack> */}
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                S.No
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Unit Code
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Report
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                Time
              </TableCell>
              <TableCell
                sx={{
                  color: "#D10101",
                  textTransform: "uppercase",
                  padding: "10px",
                  fontWeight: 600,
                }}
              >
                View
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow hover key={index}>
                  <TableCell sx={{ padding: "10px" }}>
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell sx={{ padding: "0px" }}>{row.SiteCode}</TableCell>
                  <TableCell sx={{ padding: "0px" }}>{row.NAME}</TableCell>
                  <TableCell sx={{ padding: "0px" }}>
                    {/* <DateFormatter date={row.dbdatetime} /> */}
                    {row.dbdatetime}
                  </TableCell>
                  <TableCell sx={{ padding: "0px" }}>
                    {row.ImagePath ===
                      "https://www.apsgroupapp.com/uploads/NULL" ||
                    row.ImagePath ===
                      "https://www.apsgroupapp.com/uploads/Null" ? (
                      <>Not Done</>
                    ) : (
                      <IconButton onClick={() => handleOpen(row.ImagePath)}>
                        <VisibilityIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={modalImage}
            alt="Modal Display"
            style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }}
          />
          <Stack sx={{ display: "flex", flexDirection: "row" }}>
            <IconButton onClick={rotateLeft}>
              <RotateLeftIcon />
            </IconButton>
            <IconButton onClick={rotateRight}>
              <RotateRightIcon />
            </IconButton>
          </Stack>
        </Box>
      </Modal>
    </Paper>
  );
}

export default ImageTable;
